export enum Role {
    Inscrit = "Trader Inscrit",
    Junior = "Junior",
    Expert = "Expert",
    Independant = "Indépendant",
    Pro = "Pro",
    Forme = "Formé",
    Formateur = "Formateur",
    Admin = "Admin",
    SuperAdmin = "Super Admin",
}
